import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TreasuryFormEditor from "../components/TreasuryFormEditor";

export default function TesoreriaFormulariosEditarPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { formId } = useParams();
  const listState = location.state?.listState;
  const returnTo = location.state?.returnTo || "/tesoreria/formularios";
  const isValidId = Boolean(formId && /^\d+$/.test(String(formId)) && Number(formId) > 0);

  useEffect(() => {
    if (!isValidId) {
      navigate(returnTo, { replace: true, state: { listState } });
    }
  }, [isValidId, listState, navigate, returnTo]);

  if (!isValidId) return null;
  return <TreasuryFormEditor mode="edit" formId={formId} />;
}
